/* eslint-disable fp/no-mutation */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type DismissedBandwidthBannersReduxState = {
  dismissedBandwidthBanners: string[];
};

const initialState: DismissedBandwidthBannersReduxState = {
  dismissedBandwidthBanners: [],
};

const dismissedBandwidthBannersSlice = createSlice({
  initialState,
  name: 'dismissedBandwidthBanners',
  reducers: {
    clearDismissedBandwidthBanners: (state) => {
      state.dismissedBandwidthBanners = [];
    },
    dismissBandwidthBanner: (state, { payload }: PayloadAction<string>) => {
      if (!state.dismissedBandwidthBanners.includes(payload)) {
        state.dismissedBandwidthBanners = [...state.dismissedBandwidthBanners, payload];
      }
    },
    undismissBandwidthBanner: (state, { payload }: PayloadAction<string>) => {
      state.dismissedBandwidthBanners = state.dismissedBandwidthBanners.filter((id) => id !== payload);
    },
  },
});

export const { reducer: dismissedBandwidthBannersReducer } = dismissedBandwidthBannersSlice;
export const { clearDismissedBandwidthBanners, dismissBandwidthBanner, undismissBandwidthBanner } =
  dismissedBandwidthBannersSlice.actions;
